import {objToQueryString} from '../../util';

/**
 * Sends a stat to statsd, which can be analyzed in wavefront
 */
export function stat(metric: string, value: number, tags: {[tag: string]: string} = {}): Promise<Response> {
  const urlParams = objToQueryString({metric, value, tags: JSON.stringify(tags)});
  return fetch(`/stats/stat?${urlParams}`);
}
